import { createLookup } from '../store/createLookup'

export const ASSET_TYPES_LIST = [
  {
    id: 'realProperty',
    label: 'Real Property (Houses & Land)'
  },
  {
    id: 'intellectualProperty',
    label: 'Intellectual Property'
  },
  {
    id: 'confidentialityAgreement',
    label: 'Confidentiality'
  },
  {
    id: 'sharesInvestments',
    label: 'Shares & Investments'
  },
  {
    id: 'generalGoods',
    label: 'General Goods (jewellery, vehicles, paintings, etc)'
  },
  {
    id: 'digitalAssets',
    label: 'Digital Assets (Crypto, NFT’s, site passwords, etc)'
  },
  {
    id: 'uncategorised',
    label: 'Uncategorised'
  }
]

export const DEFAULT_ASSET_TYPE = ASSET_TYPES_LIST[0]

export const getAssetType = createLookup(ASSET_TYPES_LIST, 'asset types')

export const listAllAssetTypes = () => ASSET_TYPES_LIST
